import { FC } from 'react';

import { USER_GUEST } from 'common/config';
import {
    APP_NAME,
    WELCOME_USER,
    WELCOME_NOTE_DESCRIPTION,
    REQUEST_ACCESS_DESCRIPTION
} from 'common/config/app.config';

import './WelcomeSection.scss';

type WelcomeSectionProps = {
    userName: string;
    hasAccess: boolean;
};

const WelcomeSection: FC<WelcomeSectionProps> = ({ userName, hasAccess }) => {
    const firstName =
        userName && userName.split(' ').length > 0 ? userName.split(' ')[0] : USER_GUEST;
    return (
        <div className="welcome-container">
            <div className="welcome-note"> {`Hi ${firstName}, ${WELCOME_USER}`}</div>
            <div className="app-name"> {`${APP_NAME}${String.fromCodePoint(0x02122)} Portal`}</div>
            {hasAccess ? (
                <div className="welcome-desc"> {WELCOME_NOTE_DESCRIPTION}</div>
            ) : (
                <div className="welcome-desc">{REQUEST_ACCESS_DESCRIPTION}</div>
            )}
        </div>
    );
};

export default WelcomeSection;
